import { render, staticRenderFns } from "./RateButton.vue?vue&type=template&id=78ce678a&scoped=true&"
import script from "./RateButton.vue?vue&type=script&lang=js&"
export * from "./RateButton.vue?vue&type=script&lang=js&"
import style0 from "./RateButton.vue?vue&type=style&index=0&id=78ce678a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce678a",
  null
  
)

export default component.exports